import React, { useState } from "react";
import { CheckCircle2, Circle, Gavel, Loader2, Swords } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { sleep, RunButton, useAlive } from "../phase2/shared";

const STEPS = [
  ["Ethoca / RDR alert received", "Dispute #CB-20418 · $1,240 · 'item not received'"],
  ["Order matched", "POS ticket, timestamp and card match found"],
  ["Evidence pack built", "Receipt, delivery log and signature attached"],
  ["Representment submitted", "Filed with the issuer automatically"],
];

export default function DisputeCard({ onRecovered }) {
  const [done, setDone] = useState(0);
  const [won, setWon] = useState(false);
  const [running, setRunning] = useState(false);
  const alive = useAlive();

  const run = async () => {
    setRunning(true); setDone(0); setWon(false);
    for (let i = 1; i <= STEPS.length; i += 1) { await sleep(750); if (!alive.current) return; setDone(i); }
    await sleep(700);
    if (!alive.current) return;
    setWon(true);
    setRunning(false);
    onRecovered?.("cb-20418");
  };

  return (
    <ActiveCardShell id="T3300cr" kicker="DISPUTES" title="Chargeback & Dispute Hub" Icon={Gavel}
      actions={<RunButton tid="veroogle-t3300-run" running={running} onClick={run} Icon={running ? Loader2 : Swords} label="Fight chargeback" />}>
      <ol className="relative border-l border-white/10 ml-2 space-y-3">
        {STEPS.map(([label, detail], i) => {
          const ok = i < done;
          const active = running && i === done;
          const Icon = ok ? CheckCircle2 : active ? Loader2 : Circle;
          return (
            <li key={label} data-testid={`veroogle-t3300-step-${i}`} className="pl-5 relative">
              <Icon className={`absolute -left-[9px] top-0.5 w-4 h-4 bg-[#0C1322] rounded-full ${ok ? "text-emerald-400" : active ? "text-brand-cyan animate-spin" : "text-slate-600"}`} />
              <div className={`text-sm ${ok ? "text-white" : "text-slate-500"}`}>{label}</div>
              {ok && <div className="text-xs text-slate-400">{detail}</div>}
            </li>
          );
        })}
      </ol>
      {won && (
        <div data-testid="veroogle-t3300-outcome" className="mt-4 inline-flex px-4 py-2 rounded-lg bg-emerald-500 text-navy-950 font-mono text-xs sm:text-sm font-bold tracking-[0.16em] uppercase shadow-[0_0_24px_rgba(16,185,129,0.4)] animate-in zoom-in-75 fade-in">
          Won · $1,240 recovered
        </div>
      )}
    </ActiveCardShell>
  );
}
